import { Component } from '@angular/core';
import { PcpIconComponent } from '../common/pcp-ui-icon.component';

@Component({
    selector: 'pcp-ui-difficult-question-icon',
    templateUrl: './difficult-question-icon.component.html',
    styleUrls: ['./difficult-question-icon.component.scss']
})
export class DifficultQuestionIconComponent extends PcpIconComponent {}
